export default __webpack_public_path__ + "static/media/chronic.b8fc5658.jpg";